import { Injectable } from '@angular/core';
import { SystemLog } from '@osos/shared/api';
import { SystemLogPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../../bases';
import { SystemLogsParserV1Service } from '../../../parsers/logs';
import { ParserFactory } from '../../../services';

@Injectable()
export class SystemLogsFactoryService extends FactoryBase<
  SystemLog,
  SystemLogPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: SystemLogsParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: SystemLogPresenterModel): SystemLog {
    const parser = this.getParser(SystemLog, SystemLogPresenterModel);
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(model: SystemLog): SystemLogPresenterModel {
    const parser = this.getParser(SystemLog, SystemLogPresenterModel);
    const result = parser.getPresenterModel(model);
    return result;
  }
}
